module.exports = __webpack_public_path__ + "vue_assets/img/img_setting_underdark.6d257e90.png";